if (!customElements.get('bundle-only-subscription')) {
  customElements.define(
    'bundle-only-subscription',
    class BundleOnlySubscription extends HTMLElement {
      connectedCallback() {
        this.restrictedIds = new Set(this.dataset.variantIds.split(','));
        this.scope =
          this.closest('.custom-quick-shop-wrapper') || this.closest('.product') || this.parentElement;

        this.scope.addEventListener('change', () => this.apply());

        // Ordergroove injects the selling plan input after the offer renders, so
        // keep watching instead of only checking on variant change.
        this.observer = new MutationObserver(() => this.stripSellingPlan());
        this.observer.observe(this.scope, { childList: true, subtree: true });

        this.apply();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      isRestricted() {
        const input = this.scope.querySelector('input[name="id"]');
        return !!input && this.restrictedIds.has(input.value);
      }

      apply() {
        this.scope.classList.toggle('bundle-only-subscription-active', this.isRestricted());
        this.stripSellingPlan();
      }

      // A restricted size must never reach the cart as a subscription line.
      stripSellingPlan() {
        if (!this.isRestricted()) return;
        this.scope
          .querySelectorAll('input[name="selling_plan"]')
          .forEach((input) => input.remove());
      }
    },
  );
}
